import {
  useAnalysisTypes,
  useInstallation,
  useIsotopos,
  useSamplingPoints,
  useTypeSample,
} from "@services/servicesGenericsTables";
import EquipoMideForm from "../components/forms/EquipoMide.form";
import PuntosMuestreoForm from "../components/forms/PuntosMuestreo.form";
import { columnsEquipoMide } from "./columns/EquipoMide.columns";
import { columnsMasterTables } from "./masterTables.columns";
import { useMasterTables } from "./useMasterTables";
import IsotoposInstalacionForm from "../components/forms/IsotoposInstalacion.form";
import CodigosFondoForm, {
  fixedInstallation,
} from "../components/forms/CodigosFondo.form";
import DosimetrosForm from "../components/forms/Dosimetros.form";
import DetectorForm from "../components/forms/Detector.form";
import TrazadoresForm from "../components/forms/Trazadores.form";
import PartesEficienciaForm from "../components/forms/PartesEficiencia.form";
import PreoperacionalForm from "../components/forms/Preoperacional.form";
import OperacionalForm from "../components/forms/Operacional.form";
import InstalacionesForm from "../components/forms/Instalaciones.form";
import TiposAnalisisForm from "../components/forms/TiposAnalisis.form";
import { columnsDetector } from "./columns/Detector.columns";
import { OPTIONS_ACTIVE_INACTIVE } from "@app/pages/samples/components/analysisComponents/BR/utils/constants";
import { OPTIONS_YES_NO } from "@app/pages/samples/components/analysisComponents/iodo131/utils/constants";
import EquiposForm from "../components/forms/Equipos.form";
import { columnsEquipos } from "./columns/Equipos.columns.";
import { columnsProcedimientos } from "./columns/Procedimientos.columns";
import ProcedimientosForm from "../components/forms/Procedimientos.form";
import { columnsReagents } from "./columns/Reagents.columns";
import ReagentsForm from "../components/forms/Reagents.form";
import TiposUnidadesForm from "../components/forms/TiposUnidades.form";
import { columnsTiposUnidades } from "./columns/TiposUnidades.columns";
import IsotoposForm from "../components/forms/Isotopos.form";
import { columnsIsotopos } from "./columns/Isotopos.columns";
import NivelesActividadCsnForm from "../components/forms/NivelesActividadCsn.form";

//CONFIGURACION DE SERVICIOS
export const serviceForTable = {
  EquipoMide: () => useMasterTables.getState().fetchEquipoMide(),
  PuntosMuestreo: () =>
    useMasterTables.getState().fetchSpecificTable("PuntosMuestreo"),
  IsotoposInstalacion: () =>
    useMasterTables.getState().fetchSpecificTable("IsotoposInstalacion"),
  CodigosFondo: () =>
    useMasterTables.getState().fetchSpecificTable("CodigosFondo"),
  Dosimetros: () => useMasterTables.getState().fetchSpecificTable("Dosimetros"),
  Detector: () => useMasterTables.getState().fetchSpecificTable("Detector"),
  Trazadores: () => useMasterTables.getState().fetchSpecificTable("Trazadores"),
  PartesEficiencia: () =>
    useMasterTables.getState().fetchSpecificTable("PartesEficiencia"),
  Preoperacional: () =>
    useMasterTables.getState().fetchSpecificTable("Preoperacional"),
  Operacional: () =>
    useMasterTables.getState().fetchSpecificTable("Operacional"),
  Instalaciones: () =>
    useMasterTables.getState().fetchSpecificTable("Instalaciones"),
  TiposAnalisis: () =>
    useMasterTables.getState().fetchSpecificTable("TiposAnalisis"),
  Equipos: () => useMasterTables.getState().fetchSpecificTable("Equipos"),
  Procedimientos: () =>
    useMasterTables.getState().fetchSpecificTable("Procedimientos"),
  Reagents: () => useMasterTables.getState().fetchSpecificTable("Reagents"),
  TiposUnidades: () =>
    useMasterTables.getState().fetchSpecificTable("TiposUnidades"),
  Isotopos: () =>
    useMasterTables.getState().fetchSpecificTable("Isotopos"),
  NivelesActividadCsn: () =>
    useMasterTables.getState().fetchSpecificTable("NivelesActividadCsn"),
};

//CONFIGURACION DE COLUMNAS
export const columsForTable = {
  EquipoMide: (atributtes: string[], watchType: string) =>
    columnsEquipoMide(atributtes, watchType),
  PuntosMuestreo: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  IsotoposInstalacion: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  CodigosFondo: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Dosimetros: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Detector: (atributtes: string[], watchType: string) =>
    columnsDetector(atributtes, watchType),
  Trazadores: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  PartesEficiencia: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Preoperacional: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Operacional: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Instalaciones: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  TiposAnalisis: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
  Equipos: (atributtes: string[], watchType: string) =>
    columnsEquipos(atributtes, watchType),
  Procedimientos: (atributtes: string[], watchType: string) =>
    columnsProcedimientos(atributtes, watchType),
  Reagents: (atributtes: string[], watchType: string) =>
    columnsReagents(atributtes, watchType),
  TiposUnidades: (atributtes: string[], watchType: string) =>
    columnsTiposUnidades(atributtes, watchType),
  Isotopos: (atributtes: string[], watchType: string) =>
    columnsIsotopos(atributtes, watchType),
  NivelesActividadCsn: (atributtes: string[], watchType: string) =>
    columnsMasterTables(atributtes, watchType),
};

export const configTableForm: Record<string, React.FC> = {
  PuntosMuestreo: PuntosMuestreoForm,
  EquipoMide: EquipoMideForm,
  IsotoposInstalacion: IsotoposInstalacionForm,
  CodigosFondo: CodigosFondoForm,
  Dosimetros: DosimetrosForm,
  Detector: DetectorForm,
  Trazadores: TrazadoresForm,
  PartesEficiencia: PartesEficienciaForm,
  Preoperacional: PreoperacionalForm,
  Operacional: OperacionalForm,
  Instalaciones: InstalacionesForm,
  TiposAnalisis: TiposAnalisisForm,
  Equipos: EquiposForm,
  Procedimientos: ProcedimientosForm,
  Reagents: ReagentsForm,
  TiposUnidades: TiposUnidadesForm,
  Isotopos: IsotoposForm,
  NivelesActividadCsn: NivelesActividadCsnForm
};

//GET DEFAULT VALUES
export const getDefaultValuesPuntosMuestreo = (data: Record<string, any>) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
  };
};

export const getDefaultValuesEquipoMide = (data: Record<string, any>) => {
  return {
    ...data,
    equipo: data.equipo,
    tipo_analisis: data.tipo_analisis,
  };
};

export const getDefaultValuesIsotoposInstalacion = (
  data: Record<string, any>
) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
    isotopo: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotopo),
  };
};

export const getDefaultValuesCodigosFondo = (data: Record<string, any>) => {
  const installationsList = [
    ...fixedInstallation,
    ...useInstallation.getState().installationList,
  ];
  return {
    ...data,
    tipo_codigo: installationsList.find(
      (tipo_codigo) => tipo_codigo.codigo === data.tipo_codigo
    ),
  };
};

export const getDefaultValuesDosimetros = (data: Record<string, any>) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
    puntomuestreo: useSamplingPoints
      .getState()
      .samplingPointsList.find((punto) => punto.codigo === data.puntomuestreo),
    tipomuestra: useTypeSample
      .getState()
      .sampleTypeList.find(
        (tipomuestra) => tipomuestra.codigo === data.tipomuestra
      ),
  };
};

export const getDefaultValuesDetector = (data: Record<string, any>) => {
  return {
    ...data,
    equipment: data.equipment,
  };
};

export const getDefaultValuesTrazadores = (data: Record<string, any>) => {
  return {
    ...data,
    isotopo: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotopo),
    trazador: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.trazador),
  };
};

export const getDefaultValuesPartesEficiencia = (data: Record<string, any>) => {
  return {
    ...data,
    analisis: useAnalysisTypes
      .getState()
      .analysisTypeList.find((analysis) => analysis.codigo === data.analisis),
  };
};

export const getDefaultValuesPreoperacional = (data: Record<string, any>) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
    analisis: useAnalysisTypes
      .getState()
      .analysisTypeList.find((analysis) => analysis.codigo === data.analisis),
    tipomuestra: useTypeSample
      .getState()
      .sampleTypeList.find(
        (tipomuestra) => tipomuestra.codigo === data.tipomuestra
      ),
    isotopo: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotopo),
  };
};

export const getDefaultValuesOperacional = (data: Record<string, any>) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
    analisis: useAnalysisTypes
      .getState()
      .analysisTypeList.find((analysis) => analysis.codigo === data.analisis),
    tipomuestra: useTypeSample
      .getState()
      .sampleTypeList.find(
        (tipomuestra) => tipomuestra.codigo === data.tipomuestra
      ),
    isotopo: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotopo),
  };
};

export const getDefaultValuesInstalaciones = (data: Record<string, any>) => {
  return {
    ...data,
    activo: !data.activo
      ? OPTIONS_ACTIVE_INACTIVE[1]
      : OPTIONS_ACTIVE_INACTIVE[0],
  };
};

export const getDefaultValuesTiposAnalisis = (data: Record<string, any>) => {
  return {
    ...data,
    confirmed_analysis: !data.confirmed_analysis
      ? OPTIONS_YES_NO[1]
      : OPTIONS_YES_NO[0],
    isotope_code: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotope_code),
    isotope_type: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotope_type),
  };
};

export const getDefaultValuesEquipos = (data: Record<string, any>) => {
  return {
    ...data,
    is_geometry: !data.is_geometry ? OPTIONS_YES_NO[1] : OPTIONS_YES_NO[0],
  };
};

export const getDefaultValuesProcedimientos = (data: Record<string, any>) => {
  return {
    ...data,
  };
};

export const getDefaultValuesReagents = (data: Record<string, any>) => {
  return {
    ...data,
    number_lot: data.number_lot || undefined,
    reactive_number: data.reactive_number || undefined,
    start_date_use: data.start_date_use || undefined,
    end_date_use: data.end_date_use || undefined,
  };
};

export const getDefaultValuesTiposUnidades = (data: Record<string, any>) => {
  return {
    ...data,
  };
};

export const getDefaultValuesIsotopos = (data: Record<string, any>) => {
  return {
    ...data,
  };
};

export const getDefaultValuesNivelesActividadCsn = (data: Record<string, any>) => {
  return {
    ...data,
    instalacion: useInstallation
      .getState()
      .installationList.find(
        (instalacion) => instalacion.codigo === data.instalacion
      ),
    analisis: useAnalysisTypes
      .getState()
      .analysisTypeList.find((analysis) => analysis.codigo === data.analisis),
    isotopo: useIsotopos
      .getState()
      .isotoposList.find((isotopo) => isotopo.codigo === data.isotopo),
  };
};

export const mapGetDefaultValues = {
  PuntosMuestreo: getDefaultValuesPuntosMuestreo,
  EquipoMide: getDefaultValuesEquipoMide,
  IsotoposInstalacion: getDefaultValuesIsotoposInstalacion,
  CodigosFondo: getDefaultValuesCodigosFondo,
  Dosimetros: getDefaultValuesDosimetros,
  Detector: getDefaultValuesDetector,
  Trazadores: getDefaultValuesTrazadores,
  PartesEficiencia: getDefaultValuesPartesEficiencia,
  Preoperacional: getDefaultValuesPreoperacional,
  Operacional: getDefaultValuesOperacional,
  Instalaciones: getDefaultValuesInstalaciones,
  TiposAnalisis: getDefaultValuesTiposAnalisis,
  Equipos: getDefaultValuesEquipos,
  Procedimientos: getDefaultValuesProcedimientos,
  Reagents: getDefaultValuesReagents,
  TiposUnidades: getDefaultValuesTiposUnidades,
  Isotopos: getDefaultValuesIsotopos,
  NivelesActividadCsn: getDefaultValuesNivelesActividadCsn,
};

//MAPPING POST - PUT
export const mapEquipoMide = (data) => {
  return {
    ...data,
    equipo: data.equipo.id,
    tipo_analisis: data.tipo_analisis.id,
  };
};

export const mapPuntosMuestreo = (data) => {
  return {
    ...data,
    instalacion: data.instalacion.codigo,
    activo: true,
  };
};

export const mapIsotoposInstalacion = (data) => {
  return {
    ...data,
    instalacion: data.instalacion.codigo,
    isotopo: data.isotopo.codigo,
  };
};

export const mapCodigosFondo = (data) => {
  return {
    ...data,
    tipo_codigo: data.tipo_codigo.codigo,
  };
};

export const mapTipoMuestra = (data) => {
  return {
    ...data,
    instalacion: data.instalacion.codigo,
    puntomuestreo: data.puntomuestreo.codigo,
    tipomuestra: data.tipomuestra.codigo,
    grupo: data.tipomuestra.grupo,
  };
};

export const mapDetector = (data) => {
  return {
    ...data,
    equipment: data.equipment.id,
  };
};

export const mapTrazadores = (data) => {
  return {
    ...data,
    isotopo: data.isotopo.codigo,
    trazador: data.trazador.codigo,
  };
};

export const mapPartesEficiencia = (data) => {
  return {
    ...data,
    analisis: data.analisis.codigo,
  };
};

export const mapPreoperacional = (data) => {
  return {
    ...data,
    instalacion: data.instalacion.codigo,
    isotopo: data.isotopo.codigo,
    analisis: data.analisis.codigo,
    tipomuestra: data.tipomuestra.codigo,
  };
};

export const mapOperacional = (data) => {
  return {
    ...data,
    instalacion: data.instalacion.codigo,
    isotopo: data.isotopo.codigo,
    analisis: data.analisis.codigo,
    tipomuestra: data.tipomuestra.codigo,
  };
};

export const mapInstalaciones = (data) => {
  return {
    ...data,
    activo: data.activo.value,
  };
};

export const mapTiposAnalisis = (data) => {
  return {
    ...data,
    isotope_code: data.isotope_code?.codigo,
    isotope_type: data.isotope_code?.codigo,
    confirmed_analysis: data.confirmed_analysis.value,
  };
};

export const mapEquipos = (data) => {
  const { preparations, ...rest } = data;
  return {
    ...rest,
    is_geometry: data.is_geometry.value,
    activo: 1,
  };
};

export const mapProcedimientos = (data) => {
  return {
    ...data,
    activo: 1,
  };
};

export const mapReagents = (data) => {
  return {
    ...data,
  };
};

export const mapTiposUnidades = (data) => {
  return {
    ...data,
    activo: 1,
  };
};

export const mapIsotopos = (data) => {
  return {
    ...data,
  };
};

export const mapNivelesActividadCsn = (data) => {
  return {
    ...data,
    instalacion: data.instalacion?.codigo,
    analisis: data.analisis?.codigo,
    isotopo: data.isotopo?.codigo,
  };
};

export const mapDataFunction = {
  EquipoMide: mapEquipoMide,
  PuntosMuestreo: mapPuntosMuestreo,
  IsotoposInstalacion: mapIsotoposInstalacion,
  CodigosFondo: mapCodigosFondo,
  Dosimetros: mapTipoMuestra,
  Detector: mapDetector,
  Trazadores: mapTrazadores,
  PartesEficiencia: mapPartesEficiencia,
  Preoperacional: mapPreoperacional,
  Operacional: mapOperacional,
  Instalaciones: mapInstalaciones,
  TiposAnalisis: mapTiposAnalisis,
  Equipos: mapEquipos,
  Procedimientos: mapProcedimientos,
  Reagents: mapReagents,
  TiposUnidades: mapTiposUnidades,
  Isotopos: mapIsotopos,
  NivelesActividadCsn: mapNivelesActividadCsn
};

//CONSOLIDA CONFIGURACION DE TABLAS
export const configTable = {
  PuntosMuestreo: {
    service: serviceForTable.PuntosMuestreo,
    columns: columsForTable.PuntosMuestreo,
    form: configTableForm.PuntosMuestreo,
    mapData: mapDataFunction.PuntosMuestreo,
    getDefaultValues: mapGetDefaultValues.PuntosMuestreo,
  },
  EquipoMide: {
    service: serviceForTable.EquipoMide,
    columns: columsForTable.EquipoMide,
    form: configTableForm.EquipoMide,
    mapData: mapDataFunction.EquipoMide,
    getDefaultValues: mapGetDefaultValues.EquipoMide,
  },
  IsotoposInstalacion: {
    service: serviceForTable.IsotoposInstalacion,
    columns: columsForTable.IsotoposInstalacion,
    form: configTableForm.IsotoposInstalacion,
    mapData: mapDataFunction.IsotoposInstalacion,
    getDefaultValues: mapGetDefaultValues.IsotoposInstalacion,
  },
  CodigosFondo: {
    service: serviceForTable.CodigosFondo,
    columns: columsForTable.CodigosFondo,
    form: configTableForm.CodigosFondo,
    mapData: mapDataFunction.CodigosFondo,
    getDefaultValues: mapGetDefaultValues.CodigosFondo,
  },
  Dosimetros: {
    service: serviceForTable.Dosimetros,
    columns: columsForTable.Dosimetros,
    form: configTableForm.Dosimetros,
    mapData: mapDataFunction.Dosimetros,
    getDefaultValues: mapGetDefaultValues.Dosimetros,
  },
  Detector: {
    service: serviceForTable.Detector,
    columns: columsForTable.Detector,
    form: configTableForm.Detector,
    mapData: mapDataFunction.Detector,
    getDefaultValues: mapGetDefaultValues.Detector,
  },
  Trazadores: {
    service: serviceForTable.Trazadores,
    columns: columsForTable.Trazadores,
    form: configTableForm.Trazadores,
    mapData: mapDataFunction.Trazadores,
    getDefaultValues: mapGetDefaultValues.Trazadores,
  },
  PartesEficiencia: {
    service: serviceForTable.PartesEficiencia,
    columns: columsForTable.PartesEficiencia,
    form: configTableForm.PartesEficiencia,
    mapData: mapDataFunction.PartesEficiencia,
    getDefaultValues: mapGetDefaultValues.PartesEficiencia,
  },
  Preoperacional: {
    service: serviceForTable.Preoperacional,
    columns: columsForTable.Preoperacional,
    form: configTableForm.Preoperacional,
    mapData: mapDataFunction.Preoperacional,
    getDefaultValues: mapGetDefaultValues.Preoperacional,
  },
  Operacional: {
    service: serviceForTable.Operacional,
    columns: columsForTable.Operacional,
    form: configTableForm.Operacional,
    mapData: mapDataFunction.Operacional,
    getDefaultValues: mapGetDefaultValues.Operacional,
  },
  Instalaciones: {
    service: serviceForTable.Instalaciones,
    columns: columsForTable.Instalaciones,
    form: configTableForm.Instalaciones,
    mapData: mapDataFunction.Instalaciones,
    getDefaultValues: mapGetDefaultValues.Instalaciones,
  },
  TiposAnalisis: {
    service: serviceForTable.TiposAnalisis,
    columns: columsForTable.TiposAnalisis,
    form: configTableForm.TiposAnalisis,
    mapData: mapDataFunction.TiposAnalisis,
    getDefaultValues: mapGetDefaultValues.TiposAnalisis,
  },
  Equipos: {
    service: serviceForTable.Equipos,
    columns: columsForTable.Equipos,
    form: configTableForm.Equipos,
    mapData: mapDataFunction.Equipos,
    getDefaultValues: mapGetDefaultValues.Equipos,
  },
  Procedimientos: {
    service: serviceForTable.Procedimientos,
    columns: columsForTable.Procedimientos,
    form: configTableForm.Procedimientos,
    mapData: mapDataFunction.Procedimientos,
    getDefaultValues: mapGetDefaultValues.Procedimientos,
  },
  Reagents: {
    service: serviceForTable.Reagents,
    columns: columsForTable.Reagents,
    form: configTableForm.Reagents,
    mapData: mapDataFunction.Reagents,
    getDefaultValues: mapGetDefaultValues.Reagents,
  },
  TiposUnidades: {
    service: serviceForTable.TiposUnidades,
    columns: columsForTable.TiposUnidades,
    form: configTableForm.TiposUnidades,
    mapData: mapDataFunction.TiposUnidades,
    getDefaultValues: mapGetDefaultValues.TiposUnidades,
  },
  Isotopos:{
    service: serviceForTable.Isotopos,
    columns: columsForTable.Isotopos,
    form: configTableForm.Isotopos,
    mapData: mapDataFunction.Isotopos,
    getDefaultValues: mapGetDefaultValues.Isotopos,
  },
  NivelesActividadCsn: {
    service: serviceForTable.NivelesActividadCsn,
    columns: columsForTable.NivelesActividadCsn,
    form: configTableForm.NivelesActividadCsn,
    mapData: mapDataFunction.NivelesActividadCsn,
    getDefaultValues: mapGetDefaultValues.NivelesActividadCsn,
  }
};
